import { Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { AssignAgentsComponent } from '@app/pages/common/assign-agents/assign-agents.component';
import { catchError, EMPTY, map } from 'rxjs';

@Component({
  selector: 'app-group-details',
  templateUrl: './group-details.component.html',
  styleUrls: ['./group-details.component.scss'],
})
export class GroupDetailsComponent {
  @ViewChild(AssignAgentsComponent)
  private assignAgentComponent!: AssignAgentsComponent;

  groupDetail: any;
  title: string = '';

  userRoles: any = [];
  users: any;
  //"group", "user", this.service(), "GetGroupUsers", false, false, true, !cls.
  owner = 'group';
  object = 'user';
  priorities = false;
  persistence = false;
  roles = true;
  disable;
  details: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private location: Location
  ) {
    this.route.params.subscribe((params: any) => {
     // console.log(params);
      // alert(params.id)
      this.loadGroupDetails(params.id);
    });

    const urlArray: any = this.router.url.split('/');
    urlArray.shift();
    if (urlArray.length > 0) {
      for (let i = 0; i < urlArray.length - 1; i++) {
        this.currentpath += urlArray[i] + (urlArray[i + 2] ? '>' : '');
      }
    }
    this.disable = this.securityService.validateGrant('ManageAssignments');
  }
  currentpath: any = '';

  loadGroupDetails(id: number) {
    this.managerService
      .GetGroupByID(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetGroupByID');
          if (isValid) {
            this.groupDetail = data.Response.Data;
            this.title =
              'Group ' +
              this.groupDetail.ID +
              ' - ' +
              this.groupDetail.Name +
              (this.groupDetail.Manager == null ? '' : ' (Manager: ' + this.groupDetail.Manager + ')');

            this.details = {
              ID: this.groupDetail.ID,
              owner: this.owner,
              object: this.object,
              service: this.managerService,
              method: 'GetGroupUsers',
              priorities: this.priorities,
              persistence: this.persistence,
              roles: this.roles,
              disable: !this.securityService.validateGrant('ManageAssignments'),
            };

            //  AssignmentController("group", "user", this.service(), "GetGroupUsers", false, false, true, !cls.QBRSecurity().validateGrant("ManageAssignments"));
            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  saveChanges() {
    const pl: any = {};
    const agents = [];
    const assignedAgents = this.assignAgentComponent.assignedDisplay;
    for (const agent of assignedAgents) {
      agents.push(agent.value + '|' + this.getUserRole(agent.label));
    }
    pl.agents = agents;
    pl.id = this.groupDetail.ID;
    this.managerService
      .EditGroupDetails(pl)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'EditGroupDetails');
          if (isValid) {
            this.location.back();
          }
        })
      )
      .subscribe();
  }

  getUserRole(label: any) {
    if (label.lastIndexOf(' (Manager)') > -1) {
      return 2;
    } else return 1;
  }
  goBack() {
    this.location.back();
  }
}
